<template>
  <span
    class="relative shrink-0"
    aria-hidden="true"
  >
    <span
      v-for="ring in rings"
      :key="ring.color"
      class="check-ring pointer-events-none absolute inset-0 rounded-full border-2"
      :class="ring.color"
      :style="{ '--d': ring.delay }"
      data-testid="check-ring"
    />
    <span
      class="check-stamp absolute inset-0 flex items-center justify-center rounded-full"
      :class="stampClass"
      :style="{ '--d': stampDelay }"
      data-testid="check-stamp"
    >
      <slot />
    </span>
  </span>
</template>

<script setup>
const { rings = [], stampClass = null, stampDelay = null } = defineProps({
  rings: { type: Array },
  stampClass: { type: String },
  stampDelay: { type: String },
});
</script>

<style scoped>
@keyframes check-ring {
  0% { opacity: 0; transform: scale(0.9); }
  25% { opacity: 0.8; }
  100% { opacity: 0; transform: scale(1.55); }
}

@keyframes check-stamp {
  0% { opacity: 0; transform: scale(0.4); }
  60% { transform: scale(1.16); }
  100% { opacity: 1; transform: scale(1); }
}

@keyframes check-tick { from { stroke-dashoffset: 30; } to { stroke-dashoffset: 0; } }

.check-ring { animation: check-ring 620ms cubic-bezier(0.65, 0, 0.35, 1) var(--d, 0ms) both; }
.check-stamp { animation: check-stamp 420ms cubic-bezier(0.16, 1, 0.3, 1) var(--d, 0ms) both; }
:slotted(.check-tick) { stroke-dasharray: 30; animation: check-tick 420ms cubic-bezier(0.65, 0, 0.35, 1) var(--d, 0ms) both; }

@media (prefers-reduced-motion: reduce) {
  .check-ring { animation: none; opacity: 0; }
  .check-stamp { animation: none; }
  :slotted(.check-tick) { animation: none; stroke-dashoffset: 0; }
}
</style>
